import { Swiper } from 'swiper/bundle';

const swipers = document.querySelectorAll('.js-case-swiper');

swipers.forEach((swiperInstance) => {
  intializeSwiper(swiperInstance);
});

function intializeSwiper(swiperInstance) {
  const swiperOptions = {
    slidesPerView: 'auto',
    watchOverflow: true,
    watchSlidesProgress: true,
    spaceBetween: 24,
    a11y: {
      firstSlideMessage: 'Dit is de eerste slide',
      nextSlideMessage: 'Naar de volgende slide',
      prevSlideMessage: 'Naar de vorige slide',
      lastSlideMessage: 'Dit is de laatste slide',
      paginationBulletMessage: 'Ga naar slide {{index}}',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      disabledClass: 'swiper-control-disabled',
      hiddenClass: 'swiper-control-hidden',
      lockClass: 'swiper-control-lock',
      nextEl: '.swiper-control-next',
      prevEl: '.swiper-control-prev',
    },
  };

  new Swiper(swiperInstance, swiperOptions);

  const slides = swiperInstance.querySelectorAll('.js-case-slide');
  slides.forEach((slide, index) => {
    slide.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
}

export { intializeSwiper };
